import { render } from "./user-responses-table.vue?vue&type=template&id=163832bc&ts=true"
import script from "./user-responses-table.vue?vue&type=script&lang=ts"
export * from "./user-responses-table.vue?vue&type=script&lang=ts"

import "./user-responses-table.vue?vue&type=style&index=0&id=163832bc&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__